import { render, staticRenderFns } from "./refundrecord.vue?vue&type=template&id=05d0c5a8"
import script from "./refundrecord.vue?vue&type=script&lang=js"
export * from "./refundrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports